import { colorOptions } from './Colors.options'
import { ColorsUtils } from './Colors.parts'

export const Colors = {
  options: colorOptions,
  getPattern: ColorsUtils.getPattern,
  getHighlight: ColorsUtils.getHighlight,
  mapDomain: ColorsUtils.mapDomain,
  getSequential: ColorsUtils.getSequential,
  getSemantic: ColorsUtils.getSemantic,
  getOverflow: ColorsUtils.getOverflow,
  meetsContrast: ColorsUtils.meetsContrast,
  mapColorPalette: ColorsUtils.mapColorPalette,
}
